import * as React from 'react';
import { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Stack from '@mui/material/Stack';
import AdminLayout, { AdminSection } from '../../components/AdminLayout';
import axiosInstance from '../../utils/axiosInstance';

export default function AdminGatewaysPage(props) {
  const [state, setState] = useState({ loading: true, error: '', gateways: [] });

  useEffect(() => {
    let active = true;

    async function loadGateways() {
      try {
        const response = await axiosInstance.get('/admin/gateways');
        if (!active) {
          return;
        }
        setState({
          loading: false,
          error: '',
          gateways: Array.isArray(response.data?.gateways) ? response.data.gateways : [],
        });
      } catch (error) {
        if (!active) {
          return;
        }
        setState({
          loading: false,
          error: error?.response?.data?.message || 'Unable to load gateways.',
          gateways: [],
        });
      }
    }

    loadGateways();
    return () => {
      active = false;
    };
  }, []);

  return (
    <AdminLayout
      props={props}
      breadcrumbItems={[{ label: 'AMX xConsole', href: '/' }, { label: 'Admin Dashboard', href: '/admin' }, { label: 'Gateways' }]}
      title="Gateway Pages"
      subtitle="Cross-partner gateway inventory with direct links back to partner administration."
    >
      <AdminSection title="Gateway Inventory" subtitle="All gateways registered across AMX partners.">
        {state.loading ? (
          <Stack direction="row" spacing={2} alignItems="center">
            <CircularProgress size={24} />
            <span>Loading gateways...</span>
          </Stack>
        ) : state.error ? (
          <Alert severity="error">{state.error}</Alert>
        ) : (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Gateway</TableCell>
                <TableCell>Partner</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>IoT Thing</TableCell>
                <TableCell align="right">Topics</TableCell>
                <TableCell align="right">Partner Page</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {state.gateways.map((gateway) => (
                <TableRow key={gateway.gateway_id} hover>
                  <TableCell>{gateway.display_name || gateway.gateway_code}</TableCell>
                  <TableCell>
                    {gateway.partner_display_name}
                    {gateway.business_unit_display_name ? ` / ${gateway.business_unit_display_name}` : ''}
                  </TableCell>
                  <TableCell>{gateway.status}</TableCell>
                  <TableCell>{gateway.iot_thing_name || '-'}</TableCell>
                  <TableCell align="right">{gateway.topic_count}</TableCell>
                  <TableCell align="right">
                    <Button component={RouterLink} to={`/admin/partners/${gateway.partner_id}`} variant="outlined" size="small">
                      Open Partner
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </AdminSection>
    </AdminLayout>
  );
}
